module.exports = __webpack_public_path__ + "img/dash.94b9ae90.svg";